
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AmdbAttributes } from '../../../typings/features/amdb-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';

@Component({
  selector: 'jmkw-amdb-detail',
  standalone: true,
  imports: [],
  templateUrl: './amdb-detail.component.html',
  styleUrls: ['./amdb-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AmdbDetailComponent extends AbstractDetailComponent<AmdbAttributes> {
  @Input() attributes!: AmdbAttributes;
}
